function reducer(state, action) {
  switch (action.type) {
    case "load":
      console.log("Load Data");
      return loadData(state, action.payload);
    case "changeSemester":
      console.log("Change Semester");
      return {
        ...state,
        ...{ selectedSemester: action.payload.selectedSemester },
      };
    case "changeTerm":
      console.log("Change Term");
      return { ...state, ...{ selectedTerm: action.payload.selectedTerm } };
    case "changeTab":
      console.log("Change Tab");
      return { ...state, ...action.payload };
    default:
      console.log("Unknown action");
      return state;
  }
}

const loadData = (state, dataset) => {
  const newState = { ...state, ...dataset };
  return newState;
};

export default reducer;
